import styled from "styled-components";
import { ClientSettingsDropdownTogglerIconDefaultBox } from "./client-settings-dropdown-toggler-icon.default.box";

export const ClientSettingsDropdownTogglerIconCasino888Box = styled(ClientSettingsDropdownTogglerIconDefaultBox)`
    color: ${({ isOpen, theme }) => isOpen ? theme.colors.brandPrimary : 'inherit'};
`